<div class="layout">
  <div class="noClick" *ngIf="serverSide"></div>

  <layout-header *ngIf="menuVisible"></layout-header>

  <ng-content></ng-content>
  <layout-footer></layout-footer>

  <theme-POLO-cookie-notify></theme-POLO-cookie-notify>

  <!-- Panneau de comparaison API (dev/test only) -->
  <app-api-comparison-panel *ngIf="showComparisonPanel"></app-api-comparison-panel>
</div>
